<div class="d-flex flex-column h-100 mb-5">
    <div class="flex-shrink-0">
        <div class="container">
            <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>
    </div>
</div>
<div class="row footer fixed-bottom">
    <div class ="col-xs-12 QUU_Footer">
</div>